import React, { useCallback } from 'react';
import styles from '../../styles/components/drag-and-drop/DragList.module.css';

import { move } from '@ax2/common/helpers/array';
import AddAction, { AddActionProps } from './actions/AddAction';
import { RemoveActionProps } from './actions/RemoveAction';
import DragCard, { Card, DragItemId } from './DragCard';
import _ from 'lodash';

export interface DragListProps<T extends DragItemId> {
  cards: Card<T>[];
  limit?: number;
  addAction?: AddActionProps;
  removeAction?: RemoveActionProps<T>;
  onComplete: (cards: Card<T>[]) => void; // TODO: move it to new action - MoveAction
}

// TODO: rename it to ActionList
const DragList = <T extends DragItemId>({
  cards,
  limit,
  addAction,
  removeAction,
  onComplete,
}: DragListProps<T>) => {
  const onMove = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      onComplete(move(cards, dragIndex, hoverIndex));
    },
    [cards, onComplete]
  );
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {cards.map((card, index) => (
          <DragCard
            key={card.item.id}
            {...{
              ...card,
              ...{ index, removeAction, onMove },
            }}
          />
        ))}
      </div>
      {addAction && (_.isUndefined(limit) || limit > cards.length) && (
        <AddAction {...addAction} />
      )}
    </div>
  );
};

export default DragList;
